































import { Component, Prop, Vue } from 'vue-property-decorator';
import DoughnutChart from './chartjs/DoughnutChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from './ChartError.vue';
import {Data, DataFilter, Series} from '../models';
import shortid from 'shortid';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';

@Component({
	components: {
		LoadingSpinner,
		ChartError,
		ChartNoData,
		HelpIcon,
		ChartLabels
	}
})
export default class Report extends Vue {
	@Prop() public dataEmpty: boolean;
	@Prop() public loadedData: boolean;
	@Prop() public loadingError: boolean;

	@Prop() public title: string;
	@Prop() public tooltipText: string;

	@Prop() public showLabels: boolean;

	public reportId: string = shortid();

	public get loadedAndReturnedData(): boolean {
		return this.loadedData && !this.dataEmpty;
	}

	public get loadedAndNotReturnedData(): boolean {
		return this.loadedData && this.dataEmpty;
	}
}
